module.exports = __webpack_public_path__ + "img/page-home-container1-title.a473fc92.png";